import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './formEditor.actions';
import { showConfirmationModal } from '../Common/Components/confirmation/confirmation.actions.js';
import FormEditor from './formEditor';


function mapStateToProps(state) {
  return {
    isLoading: state.formEditor.isLoading,
    isSavingTemplate: state.formEditor.isSavingTemplate,
    isFormValid: state.formEditor.isFormValid,
    isFormModified: state.formEditor.isFormModified,
    isCopyAction: state.formEditor.isCopyAction,
    isViewAction: state.formEditor.isViewAction,
    isNewTemplate: state.formEditor.isNewTemplate,
    form: state.formEditor.form,
    formTypeId: state.formEditor.formTypeId,
    lastAutoSave: state.formEditor.lastAutoSave,
    videoConfiguration: state.video.configuration,
    videoV2Configuration: state.video.videoV2Configuration,
    isVideoV2ConfigurationLoaded: state.video.isVideoV2ConfigurationLoaded,
    questionBankQuestions: state.formEditor.questionBankQuestions,
  };
}

function mapActionsToProps(dispatch) {
  return bindActionCreators({
    ...actions,
    handleCancelClick: showConfirmationModal,
  }, dispatch);
}

export default connect(mapStateToProps, mapActionsToProps)(FormEditor);
